import { render, staticRenderFns } from "./ReferralMail.vue?vue&type=template&id=670e3d2a&"
import script from "./ReferralMail.vue?vue&type=script&lang=js&"
export * from "./ReferralMail.vue?vue&type=script&lang=js&"
import style0 from "./ReferralMail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports